import { useEffect } from 'react';

/**
 * Hook для блокировки скролла body при открытых модальных окнах
 * Предотвращает прокрутку фонового контента на мобильных устройствах
 *
 * Использует безопасный подход без position:fixed (ломает скролл в iOS Safari)
 *
 * @param lock - флаг блокировки скролла
 */
export const useLockBodyScroll = (lock: boolean) => {
  useEffect(() => {
    if (!lock) return;

    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollY = window.scrollY;

    // Блокируем скролл через overflow на html (не body — Safari лучше работает с html)
    const html = document.documentElement;
    const originalHtmlOverflow = html.style.overflow;
    const originalBodyOverflow = document.body.style.overflow;

    html.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    // Компенсируем ширину скроллбара (для desktop)
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    }

    // Блокируем тач-скролл на iOS через touchmove
    const preventTouch = (e: TouchEvent) => {
      // Разрешаем скролл внутри модальных окон (элементы с overflow scroll/auto)
      let target = e.target as HTMLElement | null;
      while (target && target !== document.body) {
        const style = window.getComputedStyle(target);
        const overflowY = style.overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll') {
          const isScrollable = target.scrollHeight > target.clientHeight;
          if (isScrollable) return; // Разрешаем скролл внутри скроллируемого элемента
        }
        target = target.parentElement;
      }
      e.preventDefault();
    };

    document.addEventListener('touchmove', preventTouch, { passive: false });

    return () => {
      html.style.overflow = originalHtmlOverflow;
      document.body.style.overflow = originalBodyOverflow;
      document.body.style.paddingRight = '';
      document.removeEventListener('touchmove', preventTouch);

      // Восстанавливаем позицию скролла
      window.scrollTo(0, scrollY);
    };
  }, [lock]);
};
